import { render, staticRenderFns } from "./SubjectInfoCard.vue?vue&type=template&id=4ad9d7da&scoped=true"
import script from "./SubjectInfoCard.vue?vue&type=script&lang=js"
export * from "./SubjectInfoCard.vue?vue&type=script&lang=js"
import style0 from "./SubjectInfoCard.vue?vue&type=style&index=0&id=4ad9d7da&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad9d7da",
  null
  
)

export default component.exports